import { useToast } from "@agney/ir-toast";
import { IonButton, IonModal, IonTextarea } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { utilService } from "../../services";
import "./GlobalSearch.scss";
import Loader from "../../components/Shared/Loader/Loader";
import { globalSearchService } from "./GlobalSearch.service";
import InfiniteScroll from "react-infinite-scroll-component";
import DoctorList from "../../components/Shared/DoctorList/doctor-list";
import { CONSTANTS } from "../../constants";
import { rolePermissionsService } from "../../services/rolePermissions.service";
import _ from "lodash";
import moment from "moment";
import NoResults from "../../components/Shared/NoResults/NoResultsComponent";
import { useTranslation } from "react-i18next";
interface Props {
  searchInput: string;
  isModalPopUpScreen?: boolean;
}

const GlobalSearchPage: React.FC<any> = (props: Props) => {
  const [userListData, setUserListData]: any = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [apiParams, setApiParams]: any = useState({});
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [selectedDoctorList, setSelectedDoctorList]: any = useState([]);
  const [showFavBtn, setShowFavBtn]: any = useState(false);
  const [selectedUserGuid, setSelectedUserGuid]: any = useState();
  const [addedToFavorite, setToFavorite]: any = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [titleName, setTitleName] = useState<string>("");
  var [isInputEmpty, setIsInputEmpty] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [designation, setDesignation] = useState<string>("");
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
const { t } = useTranslation("settings");
  const Toast = useToast();

  useEffect(() => {
    fetchUsersResult(props?.searchInput, 1);
    setPageNo(1);
  }, [props?.searchInput]);

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  }, []);

  let doctorListMessage = {
    componentName: CONSTANTS.COMPONENTS.FILE_SHARE,
    isMultiSelectEnabled: false,
    isShowColorBadge: false,
  };

  
async function fetchUsersResult(searchedName: string, page: number) {
  if (page === 1) {
    setShowLoader(true);
    setUserListData([]);
  } else {
    setIsFetchingMore(true); // ✅ for pagination
  }

  const params = setParams(searchedName, page);
  const respMessageListResult =
    await globalSearchService.getSearchResultData(params);

  if (respMessageListResult.isSuccess && respMessageListResult.result?.[0]) {
    const newData = respMessageListResult.result?.[0]?.data || [];

    if (page === 1) {
      setUserListData(newData);
    } else {
      setUserListData((prev: any) => [...prev, ...newData]);
    }

    const hasMore = newData.length > 0;
    setHasMoreItems(hasMore);
    setPageNo(page);

    setTimeout(() => {
  const el = document.getElementById("scrollableDiv");
  if (el && el.scrollHeight <= el.clientHeight && hasMore) {
    console.log("Auto loading next page...");
    fetchUsersResult(searchedName, page + 1);
  }
}, 300);
  } else {
    if (page === 1) setUserListData([]);
    setHasMoreItems(false);
  }

  setShowLoader(false);
  setIsFetchingMore(false); // ✅ important
}

  const setParams = (searchedText: string, page: number) => {
    
    return {
      search_name: searchedText,
      page:  page ,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reg_code: utilService.getNetwork(),
    };
  };

  const getSelectedDoctorList = (doctorList: any) => {
    if (doctorList.length !== 0) {
      setShowFavBtn(true);
      setSelectedDoctorList(doctorList);
      setSelectedUserGuid(doctorList[0].guid);
      setToFavorite(doctorList[0].addedToFavorite);
      setDesignation(doctorList[0].designation);
    } else {
      setSelectedDoctorList([])
      setShowFavBtn(false);
    }
  };

  const addUserToFavorite = () => {
    if (!addedToFavorite) {
      let params = setFavUserParams();
      addFavUsers(params);
      setShowFavBtn(false);
    } else {
      Toast.warning(CONSTANTS.MESSAGES.USER_IN_FAVORITES);
    }
  };

  const setFavUserParams = () => {
    const currentDate: any = moment().format("YYYY-MM-DD");
    const currentHour = moment().format("HH");
    const currentMinute = moment().format("mm");
    return {
      reg_code: utilService.getNetwork(),
      date: currentDate,
      guid: selectedUserGuid,
      user_guid: utilService.getLoggedUserGuid(),
      hours: currentHour,
      minutes: currentMinute,
      designation: designation,
      title_name: titleName,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  };

  

  async function addFavUsers(params: any) {
    // setShowLoader(true);
    setIsAddedFav(true);
    const addFavUserResult = await globalSearchService.addFavoriteUsers(params);

    if (addFavUserResult.isSuccess) {
      userListData.find((doctorcarditem: any) => {
        if (doctorcarditem.guid) {
          return (doctorcarditem.isSelected = false);
        }
      });
      // clearListFunc("")

      setSelectedDoctorList([]);
      setShowFavBtn(false);

      Toast.success(t("addedFavorite"));
      setIsAddedFav(false);
    } else {
      console.log("error");
      globalSearchService.handleErrorResponse();
    }
    setShowLoader(false);
  }

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("addFavText");
    setIsInputEmpty(isWhitespace);
  };

  const [isAddedFav, setIsAddedFav] = useState<boolean>(false);

  return (
    <div className="file-share-list-container">
      <div className="file-share-select-user-header">
        <div className="add-fav-user-btn-container">
          <IonButton
            disabled={!showFavBtn}
            onClick={() => {
              setShowModal(true);
            }}
          >
            <div className="icon-add"></div>
            <span className="add-to-fav  label-padding"> {t("addToFavorite")}</span>
          </IonButton>
        </div>
      </div>

      {!showLoader ? (
      userListData.length>0 ? 
<div
  id="scrollableDiv"
  style={{
    height: "80vh",   // 🔥 REQUIRED
    overflow: "scroll",
  }}
>
<InfiniteScroll
  dataLength={userListData.length}
  next={() => {
    if (isFetchingMore) return;
    fetchUsersResult(props?.searchInput, pageNo + 1);
  }}
  hasMore={hasMoreItems}
  loader={<Loader />}
>

  
            <DoctorList
              apiParams={apiParams}
              doctorListInputData={doctorListMessage}
              doctorListDataFromParent={userListData}
              permissions={rolePermissions}
              searchText={props?.searchInput}
              getSelectedCard={getSelectedDoctorList}
              getSelectedCardAndSchedule={() => {}}
              getIsAllSelectedStatus={() => {}}
              getAllCards={() => {}}
              getAllCardsAndSchedule={() => {}}
              isFullScreen={!props.isModalPopUpScreen}
              hideFeatureButtons={false}
              isAddedFav={isAddedFav}
            ></DoctorList>
          </InfiniteScroll>
        </div> : <div style={{height:"80vh"}}>
          <NoResults />
        </div> 
      ) : (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      )}

      <IonModal
        isOpen={showModal}
        backdropDismiss={false}
        className="add-global-fav-modal"
      >
        <div className="label-div">
          <div className="label-name">{t("addToFavorite")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowModal(false);
              setTitleName("");
            }}
          ></div>
        </div>
        <div className="title-name-container">
          <div className="title-name-label">{t("titleName")}</div>
        </div>

        <div className="add-fav-text-box">
          <IonTextarea
            className="textarea-div"
            placeholder={t("enterTitleName")}
            id="addFavText"
            value={titleName}
            onIonChange={(e) => {
              checkIfInputEmpty();
              setTitleName(e.detail.value!);
            }}
          ></IonTextarea>
        </div>

        <div className="add-fav-button-container">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setTitleName("");
              }}
            >
              {t("clear")}
            </IonButton>
          </div>
          <div className="send-button-div">
            <IonButton
              disabled={isInputEmpty}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                addUserToFavorite();
                setShowModal(false);
                setTitleName("");
                setSelectedUserGuid();
              }}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default GlobalSearchPage;
